import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { SoftwareProduct } from "src/app/support/product";
import { uuid } from "src/app/support/uuid";

@Injectable()
export class CorrelationHeaderInterceptor implements HttpInterceptor {
  readonly #product = inject(PRODUCT_TOKEN);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    switch (this.#product) {
      case SoftwareProduct.BOTMASTER: {
        return next.handle(req);
      }
      default: {
        return next.handle(
          req.clone({
            headers: req.headers.set("x-snt-correlation-id", uuid())
          })
        );
      }
    }
  }
}
